import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import classes from './styles.module.scss'
import { createCn } from '../../helpers/utils';
import { File, Meet, Teams, Zoom } from '../../assets/pages';
import Modals from './modals/modals.component';

export type Options = 'file' | 'meet' | 'zoom' | 'teams'

const options: { value: Options; label: string; icon: React.ReactNode }[] = [
  { value: 'file', label: 'start-recording.file.title', icon: <File /> },
  { value: 'meet', label: 'start-recording.meet.title', icon: <Meet /> },
  { value: 'zoom', label: 'start-recording.zoom.title', icon: <Zoom /> },
  { value: 'teams', label: 'start-recording.teams.title', icon: <Teams /> },
]

const baseClass = 'start-recording'
const cn = createCn(baseClass, classes)

const StartRecordingPage = () => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState<Options | null>(null);

  return (
    <div className={cn("")}>
      <div className={cn('heading')}>{t('start-recording.heading')}</div>

      <div className={cn('options')}>
        {options.map((option) => (
          <div
            key={option.value}
            className={cn('option')}
            onClick={() => setSelectedOption(option.value)}
          >
            <div className={cn('icon')}>{option.icon}</div>
            <div className={cn('label')}>{t(option.label)}</div>
          </div>
        ))}
      </div>

      {selectedOption && <Modals type={selectedOption} setSelectedOption={setSelectedOption} />}
    </div>
  )
}

export default StartRecordingPage